import cn from 'classnames'

import styles from './spinner.module.scss'

export const SpinnerIcon = () => (
  <svg className={cn(styles.spin)} width="37" height="37" viewBox="0 0 37 37" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <path
        d="M36.73 18.264c.172 9.875-7.693 18.02-17.568 18.192C9.288 36.63 1.142 28.763.97 18.888.798 9.013 8.663.868 18.538.696 28.413.524 36.558 8.39 36.73 18.264"
        fill="#15C39A"
      />
      <path
        d="M12.156 25.834c-4.362-3.66-4.931-10.165-1.27-14.527 3.66-4.362 10.163-4.931 14.526-1.27"
        stroke="#FFF"
        strokeWidth="2.25"
        strokeLinecap="round"
      />
    </g>
  </svg>
)
